<template>
  <el-select
    v-model="dataValue"
    style="width: 160px;"
    placeholder="请选择鉴定中心"
    @change="onChage">
    <el-option
      v-if="showAll"
      label="全部鉴定中心"
      :value="null">
    </el-option>
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.roomName"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'RoomSelect',
  props: {
    value: { type: [Number, null], default: null },
    callback: { type: Function },
    showAll: { type: Boolean, default: true }
  }, // ['value', 'callback'],
  data() {
    return {
      list: []
    }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.loading = true
    this.$store.dispatch('appraise/getappraisalrooms', {
      payload: { pageNum: 1, pageSize: 100 },
      success: (res) => {
        this.loading = false
        this.list = res.data.records
      },
      fail: () => {
        this.loading = false
      }
    })
  },
  methods: {
    onChage() {
      this.callback && this.callback()
    }
  }
}
</script>
